import { defineComponent, computed } from "vue";
import { Log } from "~/extensions/utils";
import { commonStore } from "~/store/CommonStore";
const log = Log.create("TopMenuCard");
export default defineComponent({
    name: "TopMenuCard",
    setup() {
        const menus = computed(() => commonStore.topPageMenuInfo);
        return {
            menus
        };
    }
});
